export class ZFields {
    public data: Array<{ FieldName: string, FieldValue: any }> | { [id: string]: any };

    constructor(
        public useLegacy?: boolean
    ) {
        this.data = useLegacy ? [] : {};
    }

    public add(property: string, value: any) {
        if (this.useLegacy) {
            (<Array<{ FieldName: string, FieldValue: any }>>this.data).push({ FieldName: property, FieldValue: value });
        } else {
            (<{ [id: string]: any }>this.data)[property] = value;
        }
    }
}
